<div class="modal-header align-items-center">
  @if (!isCopy) {
    <h5 class="h5 modal-title pull-left semibold">
      {{ (notification?.notificationId ? 'notifications.titles.edit' : 'notifications.titles.add') | translate }}
    </h5>
  }
  @if (isCopy) {
    <h5 class="h5 modal-title pull-left semibold">
      {{ notification?.title }}
    </h5>
  }
  <button type="button" class="btn btn-icon" aria-label="Close" (click)="onClose()">
    <i class="icon-close icon-16"></i>
  </button>
</div>
<div class="modal-body">
  <form class="flex flex-column" [formGroup]="form">
    <div class="form-group" gccValidation>
      <label class="note semibold required mb-2">{{ 'notifications.form.label.select_memberFirm' | translate }}</label>
      @if (!isEditMode) {
        <gcc-multi-select formControlName="countryCode" [optionsData]="countriesSelectorData"></gcc-multi-select>
      }
      @if (isEditMode) {
        <gcc-select
          formControlName="countryCode"
          [placeholder]="'notifications.form.placeholder.select_memberFirm' | translate"
        >
          @for (country of countriesSelectorData; track country) {
            <gcc-option [value]="country.value">{{ country.label }}</gcc-option>
          }
        </gcc-select>
      }
      <gcc-validation-message for="required">{{
        'common.validation.required' | translate: { name: '' }
      }}</gcc-validation-message>
    </div>

    <div class="form-group" gccValidation>
      <label class="note semibold required mb-2">{{ 'notifications.form.label.end_date_and_time' | translate }}</label>
      <div class="d-flex align-items-center">
        <gcc-datepicker bsDatepicker formControlName="endDate" [minDate]="currentDate"></gcc-datepicker>
        <gcc-timepicker formControlName="endDate" [minDate]="currentDate" class="mx-2"></gcc-timepicker>
        <div class="note text-gray">
          {{ timezone$ | async }}
        </div>
      </div>

      <gcc-validation-message for="minDate">{{ 'common.validation.min_date' | translate }}</gcc-validation-message>
    </div>

    <div class="form-group">
      <label class="note semibold required mb-2">{{ 'notifications.form.label.type' | translate }}</label>
      <gcc-radio-group formControlName="type" name="type">
        @for (type of typeOptions; track type) {
          <gcc-radio-button [value]="type.value" [id]="'type' + type.value.toString()" class="d-block mb-3"
            >{{ type.text }}
            <span class="text-gray"
              >({{
                (type.value === notificationType['Urgent alert']
                  ? 'notifications.form.label.on_page'
                  : 'notifications.form.label.push'
                ) | translate
              }})</span
            ></gcc-radio-button
          >
        }
      </gcc-radio-group>
    </div>
    <div class="form-group" gccValidation>
      <label class="note semibold required mb-2">{{ 'notifications.form.label.title' | translate }}</label>
      <input
        class="form-control"
        type="text"
        [placeholder]="'notifications.form.placeholder.enter_title' | translate"
        formControlName="title"
      />
      <gcc-validation-message for="required">{{
        'common.validation.required' | translate: { name: '' }
      }}</gcc-validation-message>
      <gcc-validation-message for="maxlength">{{
        'common.validation.max_length' | translate: { length: TITLE_MAX_LENGTH }
      }}</gcc-validation-message>
    </div>
    <div class="form-group" gccValidation>
      <label class="note semibold mb-2">{{ 'notifications.form.label.message' | translate }}</label>
      <quill-editor
        [modules]="quillModules"
        [placeholder]="'Enter text'"
        formControlName="briefDescription"
        gccQuillEditor
        [maxLength]="BRIEF_DESCRIPTION_MAX_LENGTH"
      ></quill-editor>
      <gcc-validation-message for="required">{{
        'common.validation.required' | translate: { name: '' }
      }}</gcc-validation-message>
      <gcc-validation-message for="maxLength">{{
        'common.validation.max_length' | translate: { length: BRIEF_DESCRIPTION_MAX_LENGTH }
      }}</gcc-validation-message>
    </div>

    <div class="form-group" gccValidation>
      <label class="note semibold mb-2">{{ 'notifications.form.label.description' | translate }}</label>
      <quill-editor
        [modules]="quillModules"
        [placeholder]="'Enter detailed description'"
        formControlName="description"
        gccQuillEditor
        [maxLength]="DESCRIPTION_MAX_LENGTH"
      ></quill-editor>
      <gcc-validation-message for="maxLength">{{
        'common.validation.max_length' | translate: { length: DESCRIPTION_MAX_LENGTH }
      }}</gcc-validation-message>
    </div>
  </form>
  <div>
    <p class="caption semibold pb-2">{{ 'notifications.form.label.preview' | translate }}</p>
    <gcc-notification-item
      [notification]="form.value"
      [preview]="true"
      [ngClass]="{ w396: form.value.type !== notificationType['Urgent alert'] }"
    ></gcc-notification-item>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light m-0 ml-3" (click)="onClose()">
    {{ 'common.buttons.cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-form m-0 ml-3"
    [ngClass]="notification?.publishDate ? 'btn-primary' : 'btn-light'"
    (click)="onSave()"
    [disabled]="form.invalid"
  >
    {{ 'common.buttons.save' | translate }}
  </button>
  @if (!notification?.publishDate) {
    <button type="button" class="btn btn-primary btn-form m-0 ml-3" (click)="onSave(true)" [disabled]="form.invalid">
      {{ 'common.buttons.publish' | translate }}
    </button>
  }
</div>
